import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  privacyPolicyFile,
  complaintProcedureFile,
  termsConditionsFile,
  privacyPolicyFileEnglish,
  oldPrivacyPolicyFile,
} from "config/assets/files";
import { Link } from "react-router-dom";
import { taraliteGreenLogo, afpiLogo } from "config/assets/logos";
import { envelopeIcon, phoneIcon } from "config/assets/icons";

import "./footer.scss";
import Modal from "components/modal";
import LenderRegistrationForm from "components/lender-registration-form";

const Footer = (props) => {
  const [isRegistrationModalOpen, setRegistrationModalState] = useState(false);
  const { selected, languageData } = props.language;
  const footer = languageData[selected].footer;
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function getFAQPath() {
    const randomString = (Math.random() + 1).toString(36).substring(7);

    return `/omu/landing/borrower#faq-${randomString}`;
  }

  function documentUrl(site) {
    let url = "/";
    switch (site) {
      case "complaint_procedure":
        url = complaintProcedureFile;
        break;
      case "terms_condition":
        url = termsConditionsFile;
        break;
      case "privacy_policy":
        url = oldPrivacyPolicyFile;
        break;
      case "privacy_policy_new":
        if (selected === "en") url = privacyPolicyFileEnglish;
        else url = privacyPolicyFile;
        break;
      default:
        break;
    }
    return url;
  }

  return (
    <footer className="footer-top">
      <div className="container footer-container">
        <div className="contact-address" id="contact">
          <div className="logo">
            <img src={taraliteGreenLogo} alt="taralite-logo" />
          </div>
          <div className="contact">
            <div className="title">{footer.sitemap.head_office}</div>
            <div className="address">
              South Quarter, Tower B, Lantai 20, Unit G & H, Jl. R.A. Kartini
              Kav. 8, Kel. Cilandak Barat, Kec. Cilandak, Jakarta Selatan 12430
            </div>
            <div className="title">{footer.sitemap.cs_office}</div>
            <div className="address">
              Gedung Poins Lantai 3A, Jalan R.A Kartini No.1 Lebak Bulus,
              Jakarta Selatan 12440
            </div>
            <div className="title">{footer.sitemap.contact}</div>
            <div className="office-hours">{footer.sitemap.operating_hours}</div>
            <div className="contact-card">
              <img src={envelopeIcon} alt="mail icon" />
              <div>
                <div className="title">Email</div>
                <div className="content">customer@ovofinansial.com</div>
              </div>
            </div>
            <div className="contact-card">
              <img src={phoneIcon} alt="phone icon" />
              <div>
                <div className="title">Phone</div>
                <div className="content">021-403-20000</div>
              </div>
            </div>
          </div>
          <div>
            <iframe
              title="office-map"
              className="office-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.766919820183!2d106.78250001544028!3d-6.294332263359261!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1459c0783e7%3A0x2a7c89b9fce0bb90!2sSouth%20Quarter!5e0!3m2!1sen!2sid!4v1671690975667!5m2!1sen!2sid"
              height="200"
              style={{ border: 0, borderRadius: "12px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
            <iframe
              title="cs-office-map"
              className="office-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3965.800393833846!2d106.7781514!3d-6.2899462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f1558d5a955d%3A0xf56df5d4319c363a!2sPoins%20Mall!5e0!3m2!1sen!2sid!4v1691647921372!5m2!1sen!2sid"
              height="200"
              style={{ border: 0, borderRadius: "12px", marginTop: "8px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
        <div className="sitemap">
          <div className="title">OVO Finansial</div>
          <Link to="/about">{footer.sitemap.about}</Link>
          <Link to="/omu/landing/borrower">{footer.sitemap.products}</Link>
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={process.env.REACT_APP_LENDER_DASHBOARD_URL}
            >
              {footer.sitemap.lender_dashboard}
            </a>
          </span>
          <Link to={getFAQPath()}>{footer.sitemap.faq}</Link>
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={documentUrl("complaint_procedure")}
            >
              {footer.sitemap.complaint_procedure}
            </a>
          </span>
          <span>
            <a onClick={() => setRegistrationModalState(true)}>
            {footer.sitemap.register_as_lender}
            </a>
          </span>
        </div>
        <div className="legal">
          <span className="title">{footer.sitemap.legal}</span>
          <span>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={documentUrl("terms_condition")}
            >
              {footer.sitemap.terms_condition}
            </a>
          </span>
          <span>
            <Link to="/privacy-notice">
              {footer.sitemap.privacy_policy_new}
            </Link>
          </span>
        </div>
        <div className="official-partner">
          <div className="ojk">
            <span>{footer.ojk}</span>
            <span className="ojk-text">Otoritas Jasa Keuangan</span>
          </div>
          <div className="afpi">
            <span>{footer.afpi}</span>
            <img src={afpiLogo} alt="logo-afpi" />
          </div>
        </div>
      </div>
      <div className="attention">
        <div className="title"> {footer.tnc.attention}</div>
        <ol dangerouslySetInnerHTML={{ __html: footer.tnc.content }}></ol>
      </div>
      <div className="footer-bottom">
        <div className="copyright">© {currentYear}. All Rights Reserved.</div>
      </div>
      <Modal show={isRegistrationModalOpen} onClose={()=>{setRegistrationModalState(false)}}>
        <LenderRegistrationForm language={selected} onComplete={()=>{setRegistrationModalState(false)}}/>
      </Modal>
    </footer>
  );
};

const mapStateToProps = (state) => ({
  language: state.languageReducer,
});

export default connect(mapStateToProps, null)(Footer);
